import AddonClass from '../../../shared/classes/addon';
import Main from '../../../shared/types/enums/main';
import Rail from '../../../shared/classes/rail';
import Slider from '../../../shared/classes/slider';
import TranslationManager from '../../../shared/assets/locale/translationsManager';
import TMain from '../templates/main';
import addonObservable from '../../../shared/api/addons/addonObservable';
import useComplete from '../../../shared/components/utils/hooks/useComplete';
import { Observer } from 'rxjs';
import { appSelector } from '@shared/store/slices/app.slice';
import { modalSelector } from '../../../shared/store/slices/modal.slice';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { useAppSelector } from '../../../shared/store/hooks';
import { useEffect, useState } from 'react';
import { userSelector } from '../../../shared/store/slices/user.slice';

export default function Addon() {
  const { urls } = useAppSelector(appSelector);
  const { params: modalParams } = useAppSelector(modalSelector);
  const { parental } = useAppSelector(userSelector);
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  const [complete, setComplete] = useComplete();
  const [message, setMessage] = useState('');
  const [rails, setRails] = useState<Rail[]>([]);
  const [sliders, setSliders] = useState<Slider[]>([]);

  useEffect(() => {
    if (complete) return;

    const parentalControl =
      (currentParams as { asset: AddonClass })?.asset?.parentalControl &&
      parental?.filterAdultChannels;

    if (parentalControl) {
      setComplete(true);
      setMessage(
        TranslationManager.get(
          'PAGES.ADDON.PARENTAL_CONTROL',
          urls.account_link
        )
      );
      return;
    }

    const addonId =
      (currentParams as { asset: Slider })?.asset?.addon ||
      (currentParams as { asset: AddonClass })?.asset?.id;
    const planId = (currentParams as { asset: AddonClass })?.asset?.planId;
    const title = (currentParams as { asset: AddonClass })?.asset?.title;

    if (addonId && !complete) {
      const addonObserver: Observer<{
        data: Slider[] | Rail[];
        type: number;
      }> = {
        next: (val) => {
          if (val.type === Main.SLIDERS) {
            setSliders(val.data as Slider[]);
          } else if (val.type === Main.RAILS) {
            setRails(val.data as Rail[]);
          }
        },
        error: () => {
          console.error('Error recovering addons');
        },
        complete: () => {
          setComplete(true);
          return null;
        },
      };
      addonObservable(addonId, planId, title).subscribe(
        addonObserver as Partial<Observer<unknown>>
      );
    }
  }, [complete, currentParams, modalParams]);

  return (
    <TMain
      complete={complete}
      hideBackground={true}
      message={message}
      rails={rails}
      sliders={sliders}
      startsInMenu={false}
      startsInSlider={true}
    />
  );
}
